// extracted by mini-css-extract-plugin
module.exports = {"tagItemContainer":"filter-pills_tagItemContainer__IkDh2","tagItem":"filter-pills_tagItem__BXbsE","productFilterTags":"filter-pills_productFilterTags__JR4eu"};